module.exports = __webpack_public_path__ + "static/img/inst_dp@3x.78f453f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protectplus_britapro_com/images/inst_dp@3x.png
// module id = 1824
// module chunks = 0